import { State } from "../state/state";
import { Utils } from "../../../utils";

/**
 * @brief Convert Server side data into a UI friendly format. Mostly converts
 * numbers into booleans
 *
 * @param data:FlagsServer
 *
 * @return FlagsServer => Flags
 */
export const fromServer = (data: State.DataServer): State.Data => {
  return {
    calib: Utils.numToBool(data.calib),
    calZeros: 0,
    port_calib: Utils.numToBool(data.port_calib),
    acFail: Utils.numToBool(data.acFail),
    battFail: Utils.numToBool(data.battFail),
    inpStatus: Utils.numToBool(data.inpStatus),
    tamper: Utils.numToBool(data.tamper),
    facp: Utils.numToBool(data.facp),
    wetEol: Utils.numToBool(data.wetEol),
    relayTgl: Utils.numToBool(data.relayTgl),
    inputTrigger: Utils.numToBool(data.inputTrigger),
    resetTamper: Utils.numToBool(data.resetTamper),
    facpTamper: Utils.numToBool(data.facpTamper),
    acCommTrbl: Utils.numToBool(data.acCommTrbl),
    battTamper: Utils.numToBool(data.battTamper),
    mask: "",
    temp: Math.round(data.temp * 0.125),
    thigh: Math.round(data.thigh * 0.125)
  };
};

/**
 * @brief Prepare some flags state changes to update server format.
 * (Mostly just converts boolean's to numbers)
 *
 * @param data:Partial<State.Data>
 *
 * @return Partial<State.Data> => Partial<State.DataServer>
 */
export const toServer = (
  data: Partial<State.Data>
): Partial<State.DataServer> => {
  // Convert boolean properties into number properties of data
  let ret: Partial<State.DataServer> = Utils.convertBooleansToNumbers(data, [
    "calib",
    "port_calib",
    "acFail",
    "battFail",
    "inpStatus",
    "tamper",
    "facp",
    "wetEol",
    "relayTgl",
    "inputTrigger",
    "resetTamper",
    "acCommTrbl",
    "facpTamper",
    "battTamper"
  ]);

  // Scale temp high setting
  if (data.hasOwnProperty("thigh") && !(typeof data.thigh == "undefined")) {
    ret.thigh = Math.round(data.thigh / 0.125);
  }
  return ret;
  // return ret;
};
